<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	class="font-normal not-italic no-underline cursor-auto"
	style="text-decoration: none !important; text-decoration-line: none !important;"
	on:click|stopPropagation
>
	<slot />
</div>
